import { ApiResponse, Medicine } from '../../types';
import apiClient from '../api/client';

interface MedicineListResponse {
  success: boolean;
  data: Medicine[];
  meta?: {
    page: number;
    pageSize: number;
    count: number;
  };
}

export const medicineService = {
  search: async (keyword: string): Promise<Medicine[]> => {
    try {
      const response = await apiClient.get<MedicineListResponse>('/medicines/', {
        params: { search: keyword },
      });
      return response.data.data || [];
    } catch (error) {
      return [];
    }
  },

  getList: async (page: number = 1, pageSize: number = 50): Promise<MedicineListResponse> => {
    const response = await apiClient.get<MedicineListResponse>('/medicines/', {
      params: { page, page_size: pageSize },
    });
    return response.data;
  },
};
